import { toast } from "react-toastify";
import SalesRepository from "../../Repository/SalesRepository";

export const saleReturn = async (items, id) => {
  try {
    let { data } = await SalesRepository.salesModel({
      request: {
        method: "processSalesReturn",
        data: {
          items: items,
          _id: id,
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      toast.configure();
      toast.success("Return Successfully");
    } else {
      toast.configure();
      toast.success("Items not Returned");
    }
  } catch (err) {
    toast.configure();
    toast.success("Error");
  }
};
